import React from 'react'
import { SHr, SNavigation, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Disclaimer from '../../Assets/disclaimer.svg';
import Verified_icon from '../../Assets/verified_icon.svg';

export default class MessageInfo extends React.Component {
    onAceptar = () => { SNavigation.replace('/check/ChecklistAssignedTrailer'); }
    onCancelar = () => { SNavigation.replace('/check/MessageAlert'); }
    render() {
        return (
            <SPage center disableScroll preventBack>
                <Container flex>
                    <SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16, alignItems: "center", justifyContent: "space-between", }}>
                        <SView col={"xs-12"} center>
                            <SView col={"xs-12"} center style={{ alignItems: "center" }} row>
                                <Verified_icon width={18} height={18} fill={STheme.color.danger} style={{ marginRight: 8 }} />
                                <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}>TIEMPO DE CHEKLIST</SText>
                                <SHr height={10} />
                                <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                            </SView>
                            <SHr height={93} />
                            <SView col={"xs-12"} center>
                                <SText font='AlbertSans' bold center fontSize={22} color={STheme.color.text}>Atención Checklist Obligatorio</SText>
                                <SHr height={40} />
                                <Disclaimer width={95} height={130} />
                                <SHr height={40} />
                                <SView col={"xs-11"} center>
                                    <SText font='AlbertSans' center fontSize={20} color={STheme.color.text} >Debe completar el checklist de la Tractora y/o Remolque antes de continuar</SText>
                                </SView>
                            </SView>
                        </SView>
                        <SView col={"xs-12"}>
                            <SView col={"xs-12"} height={50} center style={{ borderRadius: 8, backgroundColor: STheme.color.secondary, }}
                                onPress={this.onAceptar} >
                                <SText font='AlbertSans' bold color={STheme.color.primary} fontSize={20}> ACEPTAR </SText>
                            </SView>
                            <SHr height={14} />
                            <SView col={"xs-12"} height={50} center style={{ borderRadius: 8, backgroundColor: STheme.color.primary, }}
                                onPress={this.onCancelar} >
                                <SText font='AlbertSans' bold color={STheme.color.text} fontSize={20}> CANCELAR </SText>
                            </SView>
                        </SView>
                    </SView>
                </Container>
                <SHr height={20} />
            </SPage>
        );
    }
}